/*
 * @Author: ningbo.kang
 * @Date: 2020-01-15 15:28:30
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-03-30 16:18:21
 * @Description: 描述
 */

/**
  *
  *
  *
const data = [
  {
    id: 'zhejiang',
    text: 'Zhejiang',
    child: [
      {
        id: 'hangzhou',
        text: 'Hangzhou',
        child: [
          {
            id: 'xihu',
            text: 'West Lake',
          },
        ],
      },
    ],
  },
  {
    id: 'jiangsu',
    text: 'Jiangsu',
    child: [
      {
        id: 'nanjing',
        text: 'Nanjing',
        child: [
          {
            id: 'zhonghuamen',
            text: 'Zhong Hua Men',
          },
        ],
      },
    ],
  },
];

const newTree = compareProperty(data, {
  value: 'id',
  label: 'text',
  children: 'child',
});

  * @param {*} data
  * @param {*} props
  */
// 递归，将树状属性翻译为需要的属性
export function compareProperty(data, props) {
  return data.map((item) => {
    let child = [];
    if (item[props.children] && item[props.children].length) {
      child = compareProperty(item[props.children], props);
    }
    return {
      value: item[props.value],
      label: item[props.label],
      children: child,
    };
  });
}
/**
 * 描述 检索对应语言的内容
 * @date 2021-03-29
 * @param {Array} value
 * @param {String} lang
 * @returns {String}
 */
export function getLangValue(value, lang) {
  const item = value.find(({ label }) => {
    if (label === lang) {
      return true;
    }
    return false;
  });
  if (item) {
    return item.value;
  }
  return '';
}

export default { compareProperty };
